/**
 * DeviceEditFormHeader.js
 *
 * Enhanced Device Edit Form Header
 * Shows important information when editing devices in approval workflow
 * Includes:
 * - Warning banner for pending approval devices
 * - Rejection reason display for rejected devices
 * - Resubmission count badge
 *
 * NOTE: In-draft devices with manager edit mode are handled by DeviceForm component
 * with its own "Device Edit Mode" banner for a cleaner UX
 */

import React from 'react';
import './DeviceEditFormHeader.css';

const DeviceEditFormHeader = ({
  deviceStatus,
  approvalStatus,
  rejectionReason,
  resubmissionCount,
  requestedAt
}) => {
  // Show nothing for active devices
  if (deviceStatus === 'active' || !deviceStatus) {
    return null;
  }

  return (
    <div className="device-edit-header">
      {/* Pending Approval Warning */}
      {deviceStatus === 'pending_approval' && approvalStatus === 'pending' && (
        <div className="edit-banner pending">
          <div className="banner-icon">⏳</div>
          <div className="banner-content">
            <strong>Device Pending Approval</strong>
            <p>
              This device is awaiting admin review. You cannot edit it until the admin reviews your submission. Once rejected, it will return to draft status where you can make corrections.
            </p>
          </div>
        </div>
      )}

      {/* Rejection Notice with Reason */}
      {deviceStatus === 'pending_approval' && approvalStatus === 'rejected' && (
        <div className="edit-banner rejected">
          <div className="banner-icon">❌</div>
          <div className="banner-content">
            <strong>Device Rejected - In Draft Mode</strong>
            <p>
              Your device submission was rejected. The device has been returned to draft status and is now fully editable. Please review the reason below and make the necessary corrections. Once you've addressed the issues, click "Submit for Approval" to resubmit.
            </p>

            {rejectionReason && (
              <div className="rejection-reason-box">
                <strong>Rejection Reason:</strong>
                <p>{rejectionReason}</p>
              </div>
            )}

            {resubmissionCount > 0 && (
              <div className="resubmission-info">
                <small>
                  This is resubmission attempt #{resubmissionCount + 1}
                </small>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceEditFormHeader;
